function IconSearch() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
      <path d="M20 20l-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

// Top search row of the palette: the icon + the always-focused text input. All
// key handling (arrows/enter/escape) is delegated up via onKeyDown.
function PaletteInput({ value, onChange, onKeyDown, placeholder, inputRef }) {
  return (
    <div className="palette-input-row">
      <span className="palette-input-icon">
        <IconSearch />
      </span>
      <input
        ref={inputRef}
        className="palette-input"
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={onKeyDown}
        autoFocus
      />
    </div>
  )
}

export default PaletteInput
